import { InjectionToken, inject } from '@angular/core';
import { MetaAdsConnector } from './meta-ads.connector';
import { MetaInstagramConnector } from './meta-instagram.connector';
import { MetaWhatsAppConnector } from './meta-whatsapp.connector';
import { OAuthRedirectConnector } from './oauth-redirect.connector';
import { CONNECTOR_KEY } from '../catalog/provider-catalog';
import type { ConnectorStrategy } from './connector-strategy';

export type ConnectorRegistry = Readonly<Record<string, ConnectorStrategy>>;

export const CONNECTOR_REGISTRY = new InjectionToken<ConnectorRegistry>(
  'integracoes.connector-registry',
  {
    providedIn: 'root',
    factory: () => {
      const metaWhatsApp = inject(MetaWhatsAppConnector);
      const metaInstagram = inject(MetaInstagramConnector);
      const metaAds = inject(MetaAdsConnector);
      const oauthRedirect = inject(OAuthRedirectConnector);
      return {
        [CONNECTOR_KEY.metaWhatsApp]: metaWhatsApp,
        [CONNECTOR_KEY.metaInstagram]: metaInstagram,
        [CONNECTOR_KEY.metaAds]: metaAds,
        [CONNECTOR_KEY.oauthRedirect]: oauthRedirect,
      };
    },
  },
);

export function resolveConnector(
  registry: ConnectorRegistry,
  key: string | undefined,
): ConnectorStrategy | null {
  if (!key) return null;
  return registry[key] ?? null;
}
